// Campañas de WhatsApp desde el servidor (migración 20261019a_campaigns.sql). Textos, límites y cuentas de la pantalla «Campañas».

// Los mismos límites que aplica la base: no se pueden cambiar desde la app.
export const CAMPAIGN_MAX_RECIPIENTS = 200;
export const CAMPAIGN_DAILY_LIMIT = 50;
export const CAMPAIGN_GAP_SECONDS = 45;

const STATUS = {
  activa: { label: 'En curso', tone: 'text-emerald-400' },
  pausada: { label: 'Pausada', tone: 'text-amber-300' },
  cancelada: { label: 'Cancelada', tone: 'text-seryi-text' },
  terminada: { label: 'Terminada', tone: 'text-sky-300' }
};
export const campaignStatus = (status) => STATUS[status] || { label: status || '—', tone: 'text-seryi-text' };

// Cuenta los mensajes de una campaña por estado y calcula el avance. «hechos» = ya no esperan: enviados, con error o cancelados.
export const summarize = (campaign, messages) => {
  const c = { pendiente: 0, enviando: 0, enviado: 0, error: 0, cancelado: 0 };
  for (const m of messages || []) if (m.campaign_id === campaign.id && m.status in c) c[m.status] += 1;
  const total = Number(campaign.total) || Object.values(c).reduce((a, b) => a + b, 0);
  const hechos = c.enviado + c.error + c.cancelado;
  return { ...c, total, percent: total ? Math.round((hechos / total) * 100) : 0 };
};

// Minutos que tardará en salir: un mensaje por minuto, con el tope diario (los que pasen de 50 siguen al día hábil siguiente).
export const estimateMinutes = (count) => Math.max(1, Math.ceil(count * CAMPAIGN_GAP_SECONDS / 60));
export const estimateText = (count) => {
  const n = Number(count) || 0;
  if (n > CAMPAIGN_DAILY_LIMIT) return `Saldrán ${CAMPAIGN_DAILY_LIMIT} por día (lunes a sábado de 8 am a 8 pm): unos ${Math.ceil(n / CAMPAIGN_DAILY_LIMIT)} días.`;
  const m = estimateMinutes(n);
  return `Saldrán de a uno, en unos ${m} ${m === 1 ? 'minuto' : 'minutos'} (lunes a sábado de 8 am a 8 pm).`;
};

// Destinatarios con su mensaje ya personalizado, tal como los recibe create_campaign.
export const buildRecipients = (clients, render) =>
  (clients || []).slice(0, CAMPAIGN_MAX_RECIPIENTS).map((c) => ({ name: c.name || '', phone: String(c.phone || ''), text: render(c) }));

export const defaultCampaignName = (templateLabel, now = new Date()) => {
  const d = now.toLocaleDateString('es-CO', { day: 'numeric', month: 'short' });
  return `${String(templateLabel || 'Campaña').replace(/^[^\p{L}\p{N}]+/u, '').trim() || 'Campaña'} · ${d}`.slice(0, 120);
};
